export default function preventDefault(e: React.BaseSyntheticEvent): void {
  e.preventDefault();
}
